// extracted by mini-css-extract-plugin
export default {"paymentIncompleteModal":"rdFLekOtYJs5UrPky5Jd","modalHeaderWrapper":"y0mUZvzgGPfkLbwtkUpa","modalHeading":"WpdHOQQnjkM_G9jCT6jc","modalBodyText":"bITIjRMeJv7m4a3FYi5z"};